module.exports = __webpack_public_path__ + "img/React-icon.29d40460.svg";